<template>
  <header class="header clearfix element_to_stick">
    <div class="container">
      <div id="logo">
        <a href="index.html">
          <img src="/static/images/moni.png" width="148px" class="logo_normal">
          <img src="http://www.ansonika.com/foogra/img/logo_sticky.svg" width="140" height="35" alt="" class="logo_sticky">
        </a>
      </div>
      <ul id="top_menu">
        <li><a href="#sign-in-dialog" id="sign-in" class="login">Sign In</a></li>
<!--        <li class="cart-icon-head"><i class="icon_cart_alt"></i></li>-->
      </ul>
      <!-- /top_menu -->
      <a href="#0" class="open_close">
        <i class="icon_menu"></i><span>Menu</span>
      </a>
      <nav class="main-menu">
        <div id="header_menu">
          <a href="#0" class="open_close">
            <i class="icon_close"></i><span>Menu</span>
          </a>
          <a href="index.html"><img src="http://www.ansonika.com/foogra/img/logo.svg" width="140" height="35" alt=""></a>
        </div>
        <ul>
          <li class="submenu">
            <a href="#0" class="show-submenu">Home</a>
            <ul>
              <li><a href="index.html">Default</a></li>
              <li class="third-level"><a href="#0">Sliders - Parallax <strong>New!</strong></a>
                <ul>
                  <li><a href="index-8.html">Revolution Slider 1</a></li>
                  <li><a href="index-9.html">Revolution Slider 2</a></li>
                  <li><a href="index-3.html">Owl Carousel</a></li>
                  <li><a href="index-10.html">Parallax Youtube</a></li>
                  <li><a href="index-11.html">Parallax Vimeo</a></li>
                  <li><a href="index-12.html">Parallax Mp4 Video</a></li>
                  <li><a href="index-13.html">Parallax Video Fullscreen</a></li>
                  <li><a href="index-14.html">Parallax Image</a></li>
                </ul>
              </li>
              <li><a href="index-15.html">Text Rotator</a></li>
              <li><a href="index-5.html">Address Autocomplete</a></li>
              <li><a href="index-6.html">Search Version 2</a></li>
              <li><a href="index-7.html">Delivery/Takeaway version</a></li>
              <li><a href="modal-advertise.html">Modal Advertise</a></li>
              <li><a href="modal-newsletter.html">Modal Newsletter</a></li>
              <li><a href="index-2.html">Video Bg Fallback Mobile</a></li>
              <li><a href="index-4.html">GDPR Cookie Bar EU Law</a></li>
            </ul>
          </li>
          <li class="submenu">
            <a href="#0" class="show-submenu">Listing</a>
            <ul>
              <li class="third-level"><a href="#0">List pages</a>
                <ul>
                  <li><a href="grid-listing-filterscol.html">List default</a></li>
                  <li><a href="grid-listing-filterscol-map.html">List with map</a></li>
                  <li><a href="listing-map.html">List side map</a></li>
                  <li><a href="grid-listing-filterscol-full-width.html">List full width</a></li>
                  <li><a href="grid-listing-filterscol-full-masonry.html">List Masonry Filter</a></li>
                  <li><a href="grid-listing-filterscol-delivery.html">List Delivery/Takeaway</a></li>
                </ul>
              </li>
              <li class="third-level"><a href="#0">Detail pages</a>
                <ul>
                  <li><a href="detail-restaurant.html">Detail page 1</a></li>
                  <li><a href="detail-restaurant-2.html">Detail page 2</a></li>
                  <li><a href="detail-restaurant-3.html">Mobile Fixed Booking</a></li>
                  <li><a href="detail-restaurant-delivery.html">Delivery/Takeaway</a></li>
                  <li><a href="detail-restaurant-4.html">Detail Menu Thumbs</a></li>
                  <li><a href="detail-restaurant-5.html">Detail Contact Form</a></li>
                </ul>
              </li>
              <li class="third-level"><a href="#0">OpenStreetMap</a>
                <ul>
                  <li><a href="grid-listing-filterscol-map-openstreetmap.html">List with map</a></li>
                  <li><a href="listing-map-openstreetmap.html">List side map</a></li>
                  <li><a href="grid-listing-filterscol-full-width-openstreetmap.html">List full width</a></li>
                  <li><a href="grid-listing-filterscol-full-masonry-openstreetmap.html">List Masonry Filter</a></li>
                </ul>
              </li>
              <li><a href="submit-restaurant.html">Submit Restaurant</a></li>
              <li><a href="submit-rider.html">Submit Rider</a></li>
              <li><a href="wishlist.html">Wishlist</a></li>
              <li><a href="booking.html">Booking</a></li>
              <li><a href="confirm.html">Confirm Booking</a></li>
              <li><a href="confirm-delivery.html">Confirm Order</a></li>
              <li><a href="booking-delivery-2.html">Order Delivery/Takeaway</a></li>
              <li><a href="booking-delivery.html">Order Delivery/Takeaway 2</a></li>
              <li><a href="admin_section/index.html" target="_blank">Admin Section <strong>New!</strong></a></li>
            </ul>
          </li>
          <li class="submenu">
            <a href="#0" class="show-submenu">Other Pages</a>
            <ul>
              <li><a href="html_rtl/index.html">RLT Version <strong>New!</strong></a></li>
              <li><a href="404.html">404 Error</a></li>
              <li><a href="modal-advertise.html">Modal 1 Cookie Session</a></li>
              <li><a href="modal-newsletter.html">Modal 2 Cookie Session</a></li>
              <li><a href="help.html">Help and Faq</a></li>
              <li><a href="blog.html">Blog</a></li>
              <li><a href="leave-review.html">Leave a review</a></li>
              <li><a href="user-logged-1.html">User Logged 1</a></li>
              <li><a href="user-logged-2.html">User Logged 2</a></li>
              <li><a href="contacts.html">Contacts</a></li>
              <li><a href="coming_soon/index.html">Coming Soon</a></li>
              <li><a href="account.html">Sign Up</a></li>
              <li><a href="icon-pack-1.html">Icon Pack 1</a></li>
              <li><a href="icon-pack-2.html">Icon Pack 2</a></li>
            </ul>
          </li>
          <li><a href="submit-restaurant.html">Submit</a></li>
          <li><a href="https://1.envato.market/dA652" target="_parent">Buy this template</a></li>
        </ul>
      </nav>
    </div>
    <!-- Sign In Modal -->
    <div id="sign-in-dialog" class="zoom-anim-dialog mfp-hide">
      <div class="modal_header">
        <h3>Sign In</h3>
      </div>
      <form>
        <div class="sign-in-wrapper">
          <a href="#0" class="social_bt facebook">Login with Facebook</a>
          <a href="#0" class="social_bt google">Login with Google</a>
          <div class="divider"><span>Or</span></div>
          <div class="form-group">
            <label>Email</label>
            <input type="email" class="form-control" name="email" id="email">
            <i class="icon_mail_alt"></i>
          </div>
          <div class="form-group">
            <label>Password</label>
            <input type="password" class="form-control" name="password" id="password" value="">
            <i class="icon_lock_alt"></i>
          </div>
          <div class="clearfix add_bottom_15">
            <div class="checkboxes float-left">
              <label class="container_check">Remember me
                <input type="checkbox">
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="float-right"><a id="forgot" href="javascript:void(0);">Forgot Password?</a></div>
          </div>
          <div class="text-center">
            <input type="submit" value="Log In" class="btn_1 full-width mb_5">
            Don’t have an account? <a href="account.html">Sign up</a>
          </div>
          <div id="forgot_pw">
            <div class="form-group">
              <label>Please confirm login email below</label>
              <input type="email" class="form-control" name="email_forgot" id="email_forgot">
              <i class="icon_mail_alt"></i>
            </div>
            <p>You will receive an email containing a link allowing you to reset your password to a new preferred one.</p>
            <div class="text-center"><input type="submit" value="Reset Password" class="btn_1"></div>
          </div>
        </div>
      </form>
      <!--form -->
    </div>
    <!-- /Sign In Modal -->
  </header>
</template>

<script>
export default {
  name: "Header"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Header.vue